import React from "react";
// import SchoolImage from "../../../../assets/RealEnglishImages/RealEnglishSchool.jpg";
import homePageImage from "../../../../assets/RealEnglishImages/homePageImage.jpg";

import { Col } from "reactstrap";
import REAL from "../../../../assets/RealEnglishImages/REAL.png";
import "./Welcome.css";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection

const HomePageWelcome = () => {
  const navigate = useNavigate(); // Hook for navigation

  // Function to handle button click and redirect to About Us page
  const handleAboutUsClick = () => {
    navigate("/AboutUs"); // Replace "/about-us" with your actual About Us route
  };

  return (
    <section className="welcome-section">
      {/* Welcome Background */}
      <div
        className="welcome-background"
        style={{ backgroundImage: `url(${homePageImage})` }}
      ></div>

      {/* Welcome Content */}
      <div className="welcome-content text-center">
        <h1 className="display-3 fw-bold text-white mb-4">
          Welcome to{" "}
          <Col xs={12} className="d-flex justify-content-center">
            <img
              src={REAL}
              className="card-logo card-logo-dark"
              alt="logo dark"
              height="57"
            />
          </Col>{" "}
          English Academy!
        </h1>
        <p className="lead text-white mb-4">
          Where English isn’t just taught—it’s lived. Step into a world of
          interactive learning, expert guidance, and award-winning facilities.
        </p>

        {/* About Us Button */}
        <button className="about-us-button" onClick={handleAboutUsClick}>
          Learn More About Us
        </button>
      </div>
    </section>
  );
};

export default HomePageWelcome;